import React from 'react'
import AboutPerson from './about-person.jsx'
import { withTranslation as translate } from 'react-i18next'
import { Trans } from 'react-i18next'

class AboutPage extends React.Component {
  componentDidMount(){
    this.props.onSetLocale(this.props.state.locale)
  }
  renderTheTeam() {
    const _t = this.props.t
  	return (
    <ul className='about-the-team'>
      <li>
        <AboutPerson
          image='about-sebastien'
          name='Sebastien Archambeaud'
          title={_t('about_page_title_founder_ceo')}
        />
      </li>
      <li>
        <AboutPerson
          image='about-sebastian-mutsson'
          name='Sebastian Mutsson'
          title={"COO/CTO"}
        />
      </li>
      <li>
        <AboutPerson
          image='about-alex'
          name='Alex Ivanchyk'
          title={_t('about_page_title_lead_backend_developer')}
        />
      </li>
      <li>
        <AboutPerson
          image='about-nikolay'
          name='Nikolay Nesterchuk'
          title={_t("about_page_title_front-end")}
        />
      </li>
      {/* <li>
        <AboutPerson
          image='about-camilla-n'
          name='Camilla N. Jörgensen'
          title={_t('about_page_title_marketing_coordinator')}
        />
      </li> */}
      {/* <li>
        <AboutPerson
          image='about-yesol-k'
          name='Yesol Kim'
          title={`${_t('about_page_title_customer_service_lead')} / ${_t('quality_assurance')}`}
        />
      </li>*/}
      {/* <li>
        <AboutPerson
          image='about-alex-p'
          name='Alex Pinkerton'
          title={_t('about_page_title_marketing_coordinator')}
        />
      </li> */}
      {/* <li>
        <AboutPerson
          image='consuelo-romano'
          name='Consuelo Romano'
          title={'UX & UI - designer'}
        />
      </li> */}
      {/*<li>
        <AboutPerson
          image='cory-lee'
          name='Cory Lee'
          title={'Brand Ambassador and Content Manager'}
        />
      </li> */}
      {/* <li>
        <AboutPerson
          image='magnus-berglund'
          name='Magnus Berglund & Dixie service dog'
          title={'Accessibility Director'}
        />
      </li> */}
      {/*<li>*/}
      {/*  <AboutPerson*/}
      {/*    image='viviana-cea'*/}
      {/*    name='Viviana Cea Rojas'*/}
      {/*    title={'Customer implementation manager'}*/}
      {/*  />*/}
      {/*</li>  */}
      {/*<li>
        <AboutPerson
          image='fatmir-s'
          name='Fatmir Seremeti &amp; Gibson, service dog'
          title={'Senior Account Manager – B2B Sales'}
        />
      </li>*/}
      {/* <li>
        <AboutPerson
          image='fabien-c'
          name='Fabien'
          title={'Backend Developer'}
        />
      </li>   */}
      {/*<li>
        <AboutPerson
          image='aleksey-nesterchuck'
          name='Aleksey Nesterchuck'
          title={'Mobile developer'}
        />
      </li>*/}
      {/* <li>
        <AboutPerson
          image='daniel-galan'
          name='Daniel Galan R.'
          title={'QA Tester & Assistant developer'}
        />
      </li> */}
      {/*<li>
        <AboutPerson
          image='evgeniy-smirnov'
          name='Evgeniy Smirnov'
          title={'BE- assistant developer'}
        />
      </li>*/}
      {/* <li>
        <AboutPerson
          image='dario-cianciarulo'
          name='Dario Cianciarulo'
          title={'AR, Outdoor/Indoor 3D/4D data analyst & visualizer'}
        />
      </li>  */}
      {/* <li>
        <AboutPerson
          image='harry-hansson'
          name='Harry Hansson'
          title={'Technical Documentation'}
        />
      </li> */}
      {/* <li>
        <AboutPerson
          image='andre-costa'
          name='André Costa'
          title={_t("about_page_title_front-end")}
        />
      </li>  */}
{/*      <li>
        <AboutPerson
          image='filip-m'
          name='Filip Mitrović'
          title={_t("about_page_title_front-end")}
        />
      </li>*/}
      {/*<li>*/}
      {/*  <AboutPerson*/}
      {/*    image='michael-c'*/}
      {/*    name='Michael Carlqvist'*/}
      {/*    title={_t("about_page_title_chief-sales-officer")}*/}
      {/*  />*/}
      {/*</li>*/}
      {/* <li>
        <AboutPerson
          image='signe'
          name='Signe Öfverberg Wierup'
          title={_t("about_page_title_junior-sales-assistant")}
        />
      </li> */}
    </ul>
  )
  }

  renderTheBoard() {
	  const _t = this.props.t
    return (
    <ul className='about-the-board'>
      <li>
        <AboutPerson
          image='about-bo'
          name='Bo Ekelund'
          title={_t('about_page_bo_title')}
          description={_t('about_page_bo_description')}
        />
      </li>
      <li>
        <AboutPerson
          image='about-jens'
          name='Jens Wittrup Willumsen'
          title={_t('about_page_jens_title')}
          description={_t('about_page_jens_description')}
        />
      </li>
      <li>
        <AboutPerson
          image='about-sebastien'
          name='Sebastien Archambeaud'
          title={_t('about_page_sebastien_title')}
          description={_t('about_page_sebastien_description')}
        />
      </li>
      <li>
        <AboutPerson
          image='about-sanna-susiluoto'
          name='Sanna Susiloto'
          title={'Board Member'}
          description={'Experienced Data Scientist with a demonstrated history of working in the financial services industry. Skilled in Predictive Modelling, Spatial and Statistical Analytics. Strong research professional with a Doctor of Philosophy (PhD) from Helsingin yliopisto'}
        />
      </li>
    </ul>
  )
  }
  renderOurInvestors() {
    const _t = this.props.t
	  return (
      <ul className='about-the-investors'>
        <li>
          <AboutPerson
            image='about-howzat'
            name='Howzat Partners'
            description={_t('about_page_investors_howsat_description')}
          />
        </li>
        <li>
          <AboutPerson
            image='about-entreprenor-invest'
            name='Entreprenörinvest Sverige'
            description={_t('about_page_investors_kamprad_description')}
          />
        </li>
        <li>
          <AboutPerson
            image='about-almi'
            name='Almi Invest'
            description={_t('about_page_investors_almi_description')}
          />
        </li>
        <li>
          <AboutPerson
            image='about-tranquility-capital'
            name='Tranquility Capital'
            description={_t('about_page_investors_tranquility_description')}
          />
        </li>
      </ul>
    )
  }
  renderOurNetwork() {
    const _t = this.props.t
	  return (
      <ul className='about-the-friends'>
        <li>
          <AboutPerson
            image='about-pelle'
            name='Pelle Sköldbäck'
            description={_t('about_page_pelle_description')}
          />
        </li>
        <li>
          <AboutPerson
            image='about-bjorn'
            name='Björn Persson'
            description={_t('about_page_bjorn_description')}
          />
        </li>

      </ul>
    )
  }

  render() {
    const _t = this.props.t
    return (
      <div className='about-page'>
        <h1>
          {_t('menu_about')}
        </h1>
        <p className='about-description'>
          {_t('about_page_description')}
        </p>
        <h2>
          {_t('about_page_header_2')}
        </h2>
        <p className='about-description'>
          {_t('about_page_text_2')}
        </p>
        <h2>
          {_t('about_page_header_3')}
        </h2>
        <p className='about-description'>
          {_t('about_page_text_3')}
        </p>
        <p className='about-description'>
          {_t('about_page_text_3_2')}
        </p>
        {/*<p className='about-description'>*/}
        {/*  <Trans i18nKey="about_page_text_3_3">If you also want to join Handiscover for this amazing startup journey, empower and enable billions of people who have some forms of disability, to discover the world, please send us your CV at <a href='mailto:contact@handiscover.com'>contact@handiscover.com</a> or check our our latest opening <a href='https://careers.handiscover.com/'>here</a>.</Trans>*/}
        {/*</p>*/}
        <div className='about-video-section'>
          <iframe src="https://www.youtube.com/embed/2c9KnXFX76o" frameBorder="0" allowFullScreen></iframe>
        </div>
        <h2>
          {_t('about_page_team_header')}
        </h2>
        {this.renderTheTeam()}
        {/* Temporarily removed board section  */}
        {/* <h2>
          {_t('about_page_board_header')}
        </h2>
        {this.renderTheBoard()} */}
        <h2>
          {_t('about_page_investors_header')}
        </h2>
        {this.renderOurInvestors()}
        <h2>
          {_t('about_page_friends_header')}
        </h2>
        {this.renderOurNetwork()}
        <h2>
          {_t('about_page_find_header')}
        </h2>
        <p className='about-description'>
        <Trans i18nKey="about_page_find_text_1">
          If you want to know more about Handiscover and get the latest updates of our journey, please follow us on <a href='https://se.linkedin.com/company/handiscover-ltd'>LinkedIn</a>
          , <a href='https://www.instagram.com/handiscoverworld'>Instagram</a>, <a href='https://www.facebook.com/Handiscover/'>Facebook</a>,
          <a href='https://twitter.com/handiscovercom'>Twitter</a> and <a href='https://www.pinterest.se/handiscover/'>Pinterest</a>.
        </Trans>
        </p>
        <p className='about-description'>
        <Trans i18nKey="about_page_find_text_2">To get more inspirations of where to travel, how to get there and which place to stay, please visit <a href={`/${this.props.state.locale}/content/home`}>here</a> for our latest travel tips, blogs and destination guides.</Trans>
        </p>
        <p className='about-description'>
        <Trans i18nKey="about_page_find_text_3">To get an overview of all company news, please check it out <a href={`/${this.props.state.locale}/content/page/social-media`}>here</a>.</Trans>
        </p>
        <p className='about-description'>
        <Trans i18nKey="about_page_find_text_4">If you want to get in touch, please email us at <a href='mailto:contact@handiscover.com'>contact@handiscover.com</a>.</Trans>
        </p>
      </div>

    )
  }
}

export default translate()(AboutPage)
